var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('indicators-points',{attrs:{"indicators":_vm.indicators,"chartdataGlobal":_vm.chartdataGlobal,"chartdataReturn":_vm.chartdataReturn,"chartdataSuggest":_vm.chartdataSuggest,"img":_vm.img,"colours":_vm.colours}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }